import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from '../../services/poleposition';
import axiosCriterion from '../../services/criterion';
import axiosPlaces from '../../services/place';
import NavCommon from '../../components/navCommon';
import warn from '../../constants/toast';
import CardContainerCommon from '../../components/cardCommon';
import {
  Card,
  Column,
  ContainerList,
  Divider,
  Img,
  ImgCheck,
  ImgCriterion,
  ImgPlace,
  Margin,
  OnPress,
  Row,
  RowLeft,
  RowRight,
  SizedBox,
  Space,
  Title,
  TitleType,
} from './styles';
import InputFileCommon from '../../components/inputFileCommon';
import InputCommon from '../../components/inputCommon';
import Expansion from '../../components/expansionCommon';
import icons from '../../constants/icons';
import { Criterios, GenericPlace } from '../../interfaces';
import RowInputCustom from '../../components/rowInputsCommon';
import BackDrop from '../../components/backDropCommon';

interface PolepositionProps {
  polepositionId: string;
  poleName: string;
  criterionsPole: Array<{id: string, name: string}>
  placesPole: Array<{id: string, name: string}>
}

const EditPolePosition = () => {
  const history = useHistory();
  const toPush = { colocacaoInicial: '0', colocacaoFinal: '0', quantidadePosicoes: '0' };
  const poleId = useLocation<PolepositionProps>()?.state?.polepositionId;
  const poleName = useLocation<PolepositionProps>()?.state?.poleName;
  const criterionsPole = useLocation<PolepositionProps>()?.state?.criterionsPole;
  const placesPope = useLocation<PolepositionProps>()?.state?.placesPole;

  const [openDrop, setOpenDrop] = useState<boolean>(false);
  const [poleType, setPoleType] = useState<number | null>(null);
  const [minutosAntecipacaoAgendamento, setMinutosAntecipacaoAgendamento] = useState<string>('');
  const [quantidadeCorretoresBeneficiados, setQuantidadeCorretoresBeneficiados] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [photoBase64, setPhotoBase64] = useState<string>('');
  const [fileName, setNameFile] = useState<string>('');
  const [photoError, setPhotoError] = useState<boolean>(false);
  const [localNameError, setLocalNameError] = useState<boolean>(false);
  const [localName, setLocalName] = useState<string>('');
  const [hasPhoto, setHasPhoto] = useState<boolean>(false);
  const [poleActive, setPoleActive] = useState<boolean>(false);
  const [placeExpansion, setPlaceExpansion] = useState<boolean>(false);
  const [criterionExpansion, setCriterionExpansion] = useState<boolean>(false);
  const [criterions, setCriterions] = useState<Array<Criterios>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [benefitInput, setBenefitInput] = useState<Array<any>>([]);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [
    places,
    setPlaces,
  ] = useState<Array<GenericPlace>>([]);

  useEffect(() => {
    if (localName && localNameError) {
      setLocalNameError(false);
    }
    if (photoBase64 && photoError) {
      setPhotoError(false);
    }
  }, [fileName, localName]);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      requestPole(),
      requestCriterions(),
      requestPlaces(),
    ]).then(() => setLoading(false)).catch(() => setLoading(false));
  }, []);

  const requestPole = async () => {
    try {
      const response = await axios.GetPolepositionById(poleId);
      setPoleType(response?.data?.data?.tipoPolePosition);
      setPoleActive(response?.data?.data?.ativo);
      setLocalName(response?.data?.data?.nome);
      setPhotoBase64(response?.data?.data?.urlImagem);
      setHasPhoto(!!response?.data?.data.urlImagem);
      setMinutosAntecipacaoAgendamento(response.data.data.minutosAntecipacaoAgendamento);
      setQuantidadeCorretoresBeneficiados(response.data.data.quantidadeCorretoresBeneficiados);
      setMessage(response.data.data.descricaoBeneficio);
      setBenefitInput(response.data.data.vantagens);
    } catch (error: any) {
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const requestCriterions = async () => {
    try {
      const response = await axiosCriterion.GetValidCriteria();
      setCriterions(response.data.data.map((item: any) => {
        criterionsPole?.map((it: any) => {
          if (item.idCriterio === it?.id) {
            item.check = true;
            return item;
          }
          return it;
        });
        return item;
      }));
    } catch (error: any) {
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const requestPlaces = async () => {
    try {
      const response = await axiosPlaces.GetValidLocations();
      setPlaces(
        response.data.data.map((item: any) => {
          placesPope?.map((it: any) => {
            if (item.idLocal === it?.id) {
              item.check = true;
              return item;
            }
            return it;
          });
          return item;
        }),
      );
    } catch (error: any) {
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const onChangeFrom = (value: any, index: string) => {
    setBenefitInput(benefitInput.map((item, it: number) => {
      if (it.toString() === index) {
        item.colocacaoInicial = value;
        return item;
      }
      return item;
    }));
  };
  const onChangeTo = (value: any, index: string) => {
    setBenefitInput(benefitInput.map((item, it: number) => {
      if (it.toString() === index) {
        item.colocacaoFinal = value;
        return item;
      }
      return item;
    }));
  };

  const onChangeEnd = (value: any, index: string) => {
    setBenefitInput(benefitInput.map((item, it: number) => {
      if (it.toString() === index) {
        item.quantidadePosicoes = value;
        return item;
      }
      return item;
    }));
  };

  const checkPlace = (id: string) => {
    setPlaces(
      places.map((item: any) => {
        if (id === item.idLocal) {
          item.check = !item.check;
          return item;
        }
        return item;
      }),
    );
  };

  const checkCriterion = (id: string) => {
    setCriterions(
      criterions.map((item: any) => {
        if (id === item.idCriterio) {
          item.check = !item.check;
          return item;
        }
        return item;
      }),
    );
  };

  const remove = (key: string) => {
    if (benefitInput.length === 1) {
      return;
    }
    setBenefitInput(benefitInput.filter((item: any, index: number) => index.toString() !== key));
  };

  function filterImg(img: String) {
    if (img.includes('jpeg')) {
      return img.replace('data:image/jpeg;base64,', '');
    }
    if (img.includes('png')) {
      return img.replace('data:image/png;base64,', '');
    }
    return '';
  }

  const updatePoleposition = async () => {
    try {
      setLoadingSave(true);
      if (poleType === 1) {
        await axios.updatePolepostion(
          localName,
          fileName,
          message,
          filterImg(photoBase64),
          criterions,
          places,
          benefitInput,
          1,
          poleId,
        );
      }
      if (poleType === 2) {
        await axios.updatePolepostionToAnticipation(
          localName,
          fileName,
          message,
          filterImg(photoBase64),
          criterions,
          places,
          benefitInput,
          2,
          Number(minutosAntecipacaoAgendamento),
          Number(quantidadeCorretoresBeneficiados),
          poleId,
        );
      }
      if (poleType === 3) {
        await axios.updatePolepostionBloqued(
          localName,
          fileName,
          message,
          filterImg(photoBase64),
          criterions,
          places,
          benefitInput,
          3,
          Number(quantidadeCorretoresBeneficiados),
          poleId,
        );
      }
      setLoadingSave(false);
      warn.wargingSuccess('Pole position atualizado com sucesso!');
    } catch (error: any) {
      setLoadingSave(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const updateState = async (id: string, status: boolean) => {
    try {
      setLoadingSave(true);
      await axios.updateStatusPole(id, status);
      setPoleActive(!status);
      setLoadingSave(false);
      warn.wargingSuccess(status ? 'Pole position desativado com sucesso!' : 'Pole position ativado com sucesso!');
    } catch (error: any) {
      setLoadingSave(false);
      warn.wargingError(`${error?.response?.data?.notifications?.map((item: any) => `${item.message}\n`) || 'Erro status 500!'}`);
    }
  };

  const Body = () => (
    <Margin>
      <Column>
        <Row>
          <RowLeft>
            <InputFileCommon
              hasPhoto={hasPhoto}
              setHasPhoto={setHasPhoto}
              onChange={setPhotoBase64}
              onChangeFileName={setNameFile}
              photo={photoBase64}
              isError={photoError}
            />
          </RowLeft>
          <Space />
          <RowRight>
            <InputCommon
              isDisabled={false}
              isError={localNameError}
              type="text"
              placeholder="Nome"
              value={localName}
              onChange={setLocalName}
            />
          </RowRight>
        </Row>
        {poleType === 1 && (
        <Column style={{ marginTop: 40 }}>
          <TitleType>Vantagens por posição</TitleType>
          <Divider />
          <Row>
            <RowRight style={{ width: '100%' }}>
              <InputCommon
                isDisabled={false}
                isError={false}
                type="text"
                multiline
                row={3}
                placeholder="Mensagem para o corretor"
                value={message}
                onChange={setMessage}
              />
            </RowRight>
          </Row>
          <SizedBox />
          <ContainerList>
            {benefitInput.map((item: any, index: number) => (
              <>
                <SizedBox style={{ height: 10 }} />
                <RowInputCustom
                  id={index.toString()}
                  remove={remove}
                  onChangeFrom={onChangeFrom}
                  onChangeTo={onChangeTo}
                  onChangeEnd={onChangeEnd}
                  from={item.colocacaoInicial}
                  to={item.colocacaoFinal}
                  end={item.quantidadePosicoes}
                />
              </>
            ))}
          </ContainerList>
          <SizedBox style={{ height: 10 }} />
          <RowLeft>
            <OnPress onClick={() => {
              setBenefitInput((state) => [...state, toPush]);
            }}
            >
              <Img
                height={24}
                width={24}
                src={icons.plusGreenIcon}
              />
            </OnPress>
          </RowLeft>
          <SizedBox />
        </Column>
        )}
        {(poleType === 3 || poleType === 2) && (
        <Column style={{ marginTop: 40 }}>
          <TitleType>Entrada Antecipada</TitleType>
          <Divider />
          <Row>
            <RowLeft>
              {poleType === 2 && (
              <>
                <InputCommon
                  isDisabled={false}
                  isError={false}
                  type="number"
                  placeholder="Entrará quanto tempo antes?"
                  value={minutosAntecipacaoAgendamento}
                  onChange={setMinutosAntecipacaoAgendamento}
                />
                <Space />
              </>
              )}
              <InputCommon
                isDisabled={false}
                isError={false}
                type="number"
                placeholder="Quantos corretores?"
                value={quantidadeCorretoresBeneficiados}
                onChange={setQuantidadeCorretoresBeneficiados}
              />
              <Space style={{ width: 14 }} />
            </RowLeft>
            <RowRight>
              <Space style={{ width: 20 }} />
              <InputCommon
                isDisabled={false}
                isError={false}
                type="text"
                multiline
                row={1}
                placeholder="Mensagem para o corretor"
                value={message}
                onChange={setMessage}
              />
            </RowRight>
          </Row>
          <SizedBox />
        </Column>
        )}
      </Column>
    </Margin>
  );
  const Criterions = () => (
    <ContainerList style={{ flexDirection: 'row' }}>
      {
       criterions.map((item) => (
         <Card onClick={() => checkCriterion(item.idCriterio)} key={item.idCriterio}>
           <ImgCriterion src={`data:image/png;base64,${item.iconeBase64}`} />
           <Row style={{ width: '100%', justifyContent: 'space-around', marginTop: 10 }}>
             <Column style={{ width: '80%' }}>
               <Title style={{ marginLeft: 24, paddingRight: 20 }}>{item.nome}</Title>
             </Column>
             <Column style={{ width: '20%' }}>
               <ImgCheck
                 height={16}
                 width={16}
                 src={item.check ? icons.checkIcon : icons.unCheckIcon}
               />
             </Column>
           </Row>
         </Card>
       ))
     }
    </ContainerList>
  );
  const Places = () => (
    <ContainerList style={{ flexDirection: 'row' }}>
      {
       places.map((item) => (
         <Card onClick={() => checkPlace(item.idLocal)} key={item.idLocal}>
           <ImgPlace src={item.urlImagem} />
           <Row
             style={{
               width: '100%',
               justifyContent: 'space-around',
               marginTop: 10,
             }}
           >
             <Column style={{ width: '80%' }}>
               <Title style={{ marginLeft: 24, paddingRight: 20 }}>{item.nome}</Title>
             </Column>
             <Column style={{ width: '20%' }}>
               <ImgCheck
                 height={16}
                 width={16}
                 src={item.check ? icons.checkIcon : icons.unCheckIcon}
               />
             </Column>
           </Row>
         </Card>
       ))
     }
    </ContainerList>
  );

  return (
    <>
      {loadingSave && (
        <BackDrop />
      )}
      <NavCommon
        breadcrumbs={[
          { path: '/polipositions', name: 'Pole positions' },
          { path: '', name: poleName || '' },
        ]}
        showDrop={false}
        hasOnChange
        isSave
        onSave={updatePoleposition}
        onBack={() => { history.goBack(); }}
        setOpen={setOpenDrop}
        open={openDrop}
        onChange={() => history.push('/novo-poleposition')}
      />
      <CardContainerCommon
        isSwitch
        id={poleId}
        onChangeSwitch={updateState}
        isLoading={loading}
        switchValue={poleActive}
        title="Edição do pole position"
        childrens={Body()}
        hasFilter={false}
      />
      <Margin style={{ paddingTop: 0 }}>
        {!loading && (
          <>
            <Expansion
              expanded={placeExpansion}
              title="Locais"
              icon={icons.pinIcon}
              setOpen={setPlaceExpansion}
              component={Places()}
            />
            <SizedBox style={{ height: 10 }} />
            <Expansion
              title="Critérios"
              expanded={criterionExpansion}
              icon={icons.discretionIcon}
              setOpen={setCriterionExpansion}
              component={Criterions()}
            />
          </>
        )}
      </Margin>
    </>
  );
};
export default EditPolePosition;
